import { findEdlinkIdentity, findGoogleIdentity, type UserIdentityLike } from '@airreading/auth/identity';
import { UserIdentityProviderKey, UserIdentityStatus, type UpdateUserIdentitiesOptions } from '@airreading/common/data';

function findIdentityForProvider(
  provider: UserIdentityProviderKey,
  identities: UserIdentityLike[],
): UserIdentityLike | undefined {
  return provider === UserIdentityProviderKey.google ? findGoogleIdentity(identities) : findEdlinkIdentity(identities);
}

function getProviderIdentity(provider: UserIdentityProviderKey, user: WithUserIdentities): UserIdentityLike {
  const identity = findIdentityForProvider(provider, user.userIdentities);

  if (identity) {
    return { status: identity.status, iss: identity.iss, sub: identity.sub ?? '' };
  }

  return { status: UserIdentityStatus.inactive, iss: '', sub: '' };
}

export interface WithUserIdentities {
  id: string;
  userIdentities: UserIdentityLike[];
}

export function buildUserIdentitiesDefaultValues(user: WithUserIdentities): UpdateUserIdentitiesOptions {
  return {
    google: getProviderIdentity(UserIdentityProviderKey.google, user),
    edlink: getProviderIdentity(UserIdentityProviderKey.edlink, user),
  };
}
